
import { Component, Vue, Prop } from 'vue-property-decorator';

export interface TextImageData {
  title: string;
  text: string[];
  imageUrl: string;
}

@Component({
  components: {}
})
export default class TextImage extends Vue {
  @Prop({ required: true })
  protected data?: TextImageData;
}
